import { Task } from '../../types'
import { Box } from '../../../../../shared_components/UI/Box'
import { ProgressBar } from './styles'
import { useSelector } from 'react-redux'
import { selectXpData } from '../../../../../modules/missionControl/selectors'
import { Frequency, getRecurringTimeLeft } from '../../../../../utils/recurring'
import styled from 'styled-components'
import { Info } from '../../../../../shared_components/Missions/styles'
import TaskDescription from '../../../../../shared_components/Missions/TaskDescription'
import { TaskCard } from '../../../../../shared_components/Library/Card'

export const Icon = styled.img<{ smallMargin?: boolean }>`
  width: 18px;
  height: 18px;
`

export const ResetInfo = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`

const RollupTaskCard = ({
  task,
  projectStatus,
}: {
  task: Task
  projectStatus?: 'ended' | 'active' | 'coming-soon'
}) => {
  const { pendingNonDropMissionsCount, totalRollupXp } =
    useSelector(selectXpData) ?? {}
  const { maxMissions, xpReward, internalName: description } = task

  const completedMissions =
    maxMissions - (pendingNonDropMissionsCount ?? maxMissions)

  const isComplete = completedMissions === maxMissions
  const isDisabled = isComplete || projectStatus !== 'active'

  return (
    <TaskCard fw ac isFaded={isDisabled}>
      <Box afs g={16}>
        <Box dc g={6} className="task-info">
          <Box g={40} ac>
            <Box dc g={6}>
              <TaskDescription>{description}</TaskDescription>
              <Box g={4} ac>
                <Info type="primary">+{xpReward} XP</Info>/ COMPLETION
              </Box>
            </Box>
            <span>
              {isDisabled && (
                <Info type="primary" bordered>
                  {isComplete
                    ? 'COMPLETED'
                    : projectStatus === 'coming-soon'
                    ? 'SOON'
                    : 'EXPIRED'}
                </Info>
              )}
            </span>
          </Box>
          <ProgressBar length={maxMissions} filled={completedMissions} />
          <Box jsb>
            <Info type="primary">{totalRollupXp ?? 0} XP</Info>
            {task.frequency !== Frequency.NONE && (
              <ResetInfo>
                <Icon
                  src="/img/icons/reset.svg"
                  alt="chain warning"
                  smallMargin
                />
                RESETS IN {getRecurringTimeLeft(task.frequency)}
              </ResetInfo>
            )}
          </Box>
        </Box>
      </Box>
    </TaskCard>
  )
}

export default RollupTaskCard
